import React from "react";
import { Helmet } from "react-helmet-async";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
import Footer from "components/footers/SimpleFiveColumn.js";
import { SectionHeading } from "components/misc/Headings";
import { Link } from "react-router-dom";

const HeadingRow = tw.div`flex`;
const Heading = tw(SectionHeading)`text-gray-900 mb-10`;
const Text = styled.div`
  ${tw`text-lg  text-gray-800`}
  p {
    ${tw`mt-2 leading-loose`}
  }
  h1 {
    ${tw`text-3xl font-bold mt-10`}
  }
  h2 {
    ${tw`text-2xl font-bold mt-8`}
  }
  h3 {
    ${tw`text-xl font-bold mt-6`}
  }
  ul {
    ${tw`list-disc list-inside`}
    li {
      ${tw`ml-2 mb-3`}
      p {
        ${tw`mt-0 inline leading-normal`}
      }
    }
  }
`;

export default ({ headingText = "Disclaimer" }) => {
  return (
    <AnimationRevealPage>
      <Helmet>
        <title>Disclaimer | EthosHub</title>
        <meta name="description" content="Important information about the scope and limitations of the guidance provided on the EthosHub website." />
        <link rel="canonical" href="https://www.ethoshub.io/disclaimer" />
        <meta property="og:title" content="Disclaimer | EthosHub" />
        <meta property="og:description" content="Important information about the scope and limitations of the guidance provided on the EthosHub website." />
        <meta property="og:url" content="https://www.ethoshub.io/disclaimer" />
      </Helmet>
      <Header />
      <Container>
        <ContentWithPaddingXl>
          <HeadingRow>
            <Heading>{headingText}</Heading>
          </HeadingRow>
          <Text>
            <p>Last updated: 12 June 2025</p>

            <p>
              This Disclaimer applies to the website located at{" "}
              <a href="https://www.ethoshub.io">www.ethoshub.io</a> and all associated content, operated by
              Inspired Cloud Solutions Ltd (trading as EthosHub, "we", "our", "us"), a company registered in
              England and Wales.
            </p>

            <h2>1. General Information Only</h2>
            <p>
              The information provided on this website is for general informational purposes only. While we
              make every effort to keep the content accurate and up to date, we make no warranties or
              representations — express or implied — about the completeness, accuracy, reliability, or
              suitability of any information on this site.
            </p>

            <h2>2. Not Legal or Professional Advice</h2>
            <p>
              Nothing on this website constitutes legal, HR, employment, or professional advice of any kind.
              If you are dealing with a workplace incident or legal matter, you should seek advice from a
              qualified solicitor, HR professional, or other relevant expert.
            </p>

            <h2>3. Platform Use</h2>
            <p>
              EthosHub is a software platform designed to facilitate workplace misconduct reporting. Use of
              the platform is subject to our{" "}
              <Link to="/terms-of-service">Terms of Service</Link>. The platform is intended for use by
              organisations and their employees — we cannot guarantee outcomes from its use.
            </p>

            <h2>4. Limitation of Liability</h2>
            <p>
              To the fullest extent permitted by applicable law, Inspired Cloud Solutions Ltd shall not be
              liable for any direct, indirect, incidental, or consequential loss or damage arising from your
              use of, or reliance on, this website or its content.
            </p>
            <p>
              Nothing in this Disclaimer excludes or limits our liability for death or personal injury caused
              by negligence, fraud, or any other liability that cannot be excluded by English law.
            </p>

            <h2>5. Third-Party Links</h2>
            <p>
              This website may contain links to external websites operated by third parties. These links are
              provided for your convenience only. We have no control over the content of those sites and
              accept no responsibility for them or for any loss or damage that may arise from your use of them.
            </p>

            <h2>6. Intellectual Property</h2>
            <p>
              All content on this website — including text, graphics, logos, and software — is the property
              of Inspired Cloud Solutions Ltd or its content suppliers and is protected by United Kingdom and
              international copyright law. You may not reproduce, distribute, or use any content without
              prior written permission.
            </p>

            <h2>7. Governing Law</h2>
            <p>
              This Disclaimer shall be governed by and construed in accordance with the laws of England and
              Wales. Any disputes shall be subject to the exclusive jurisdiction of the courts of England and
              Wales.
            </p>

            <h2>8. Contact Us</h2>
            <p>If you have any questions about this Disclaimer, please contact:</p>
            <p>
              <strong>Inspired Cloud Solutions Ltd</strong> (trading as EthosHub)<br />
              Email: <a href="mailto:support@ethoshub.io">support@ethoshub.io</a><br />
              Website: <a href="https://www.ethoshub.io">www.ethoshub.io</a>
            </p>
          </Text>
        </ContentWithPaddingXl>
      </Container>
      <Footer />
    </AnimationRevealPage>
  );
};
